<div class="upsell-preview" [ngStyle]="mainBackgroundStyle">
  @if (showInlineBar) {
    <div class="upsell-preview__timer-bar" [ngStyle]="timerStyle">
      <span class="upsell-preview__timer-left">
        @if (timerIconUrl) {
          <img [src]="timerIconUrl" class="upsell-preview__timer-icon" alt="" />
        }
        <span [innerHTML]="timerMessageHtml"></span>
      </span>
      <span class="upsell-preview__timer-count">{{ countdown }}</span>
    </div>
  }

  @if (showBadge) {
    <div class="upsell-preview__timer-badge" [ngStyle]="timerStyle">
      @if (timerIconUrl) {
        <img [src]="timerIconUrl" class="upsell-preview__timer-icon" alt="" />
      }
      <span [innerHTML]="timerMessageHtml"></span>
    </div>
  }

  <div class="upsell-preview__header">
    <div class="upsell-preview__title" [style.color]="sectionTitleColor || null">
      <span [innerHTML]="sectionTitleHtml"></span>
      @if (showAppendedCountdown) {
        <span class="upsell-preview__title-countdown"> - Only for {{ countdown }}</span>
      }
    </div>

    @if (showNav) {
      <div class="upsell-preview__nav">
        <button type="button" class="upsell-preview__nav-btn" [ngStyle]="navStyle" aria-label="Previous">‹</button>
        <button type="button" class="upsell-preview__nav-btn" [ngStyle]="navStyle" aria-label="Next">›</button>
      </div>
    }
  </div>

  <div
    class="upsell-preview__products"
    [class.upsell-preview__products--carousel]="isCarousel"
    [class.upsell-preview__products--scroll]="isCarouselScroll"
    [class.upsell-preview__products--compact]="isCompact">
    @if (isCompact) {
      <div class="upsell-preview__product" [ngStyle]="productItemStyle">
        <div class="upsell-preview__compact-row">
          <div class="upsell-preview__product-image" [ngStyle]="imageStyle"></div>
          <div class="upsell-preview__compact-info">
            <div class="upsell-preview__product-name">{{ firstProduct.name }}</div>
            <div class="upsell-preview__product-price">
              ${{ firstProduct.price }}
              @if (showCompareAt && firstProduct.compareAt) {
                <span class="upsell-preview__compare-at">${{ firstProduct.compareAt }}</span>
              }
            </div>
            @for (text of displayTexts; track $index) {
              <div class="upsell-preview__attr">{{ text }}</div>
            }
          </div>
        </div>
        <button type="button" class="upsell-preview__add" [ngStyle]="buttonStyle">{{ addButtonLabel }}</button>
      </div>
    } @else {
      @for (product of visibleProducts; track product.name) {
        <div class="upsell-preview__product" [ngStyle]="productItemStyle">
          @if (isCarousel) {
            <div class="upsell-preview__product-body">
              <div class="upsell-preview__product-image" [ngStyle]="imageStyle"></div>
              <div class="upsell-preview__product-name">{{ product.name }}</div>
              <div class="upsell-preview__product-price">
                ${{ product.price }}
                @if (showCompareAt && product.compareAt) {
                  <span class="upsell-preview__compare-at">${{ product.compareAt }}</span>
                }
              </div>
              @for (text of displayTexts; track $index) {
                <div class="upsell-preview__attr">{{ text }}</div>
              }
            </div>
            <div class="upsell-preview__action-row">
              @if (product.hasVariant && showVariantInline) {
                <div class="upsell-preview__variant" [ngStyle]="variantStyle">
                  <span>{{ sampleVariantLabel }}</span>
                  <pdq-icon icon="arrow_down" size="smaller"></pdq-icon>
                </div>
              }
              <button type="button" class="upsell-preview__add" [ngStyle]="buttonStyle">{{ addButtonLabel }}</button>
            </div>
          } @else {
            <div class="upsell-preview__list-left">
              <div class="upsell-preview__product-image" [ngStyle]="imageStyle"></div>
              <div class="upsell-preview__list-info">
                <div class="upsell-preview__product-name">{{ product.name }}</div>
                <div class="upsell-preview__product-price">
                  ${{ product.price }}
                  @if (showCompareAt && product.compareAt) {
                    <span class="upsell-preview__compare-at">${{ product.compareAt }}</span>
                  }
                </div>
                @if (product.hasVariant && showVariantInline) {
                  <div class="upsell-preview__variant" [ngStyle]="variantStyle">
                    <span>{{ sampleVariantLabel }}</span>
                    <pdq-icon icon="arrow_down" size="smaller"></pdq-icon>
                  </div>
                }
                @for (text of displayTexts; track $index) {
                  <div class="upsell-preview__attr">{{ text }}</div>
                }
              </div>
            </div>
            <button type="button" class="upsell-preview__add" [ngStyle]="buttonStyle">{{ addButtonLabel }}</button>
          }
        </div>
      }
    }
  </div>
</div>
